import { PropsWithRef } from 'react';

interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function TestnetIcon(props: PropsWithRef<Props>) {
  const { size = 17, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.58 11.58c-4.08 4.07-8.76 6-10.46 4.3-1.7-1.7.23-6.38 4.3-10.46 4.08-4.07 8.76-6 10.46-4.3 1.7 1.7-.23 6.38-4.3 10.46Zm0-6.16c4.07 4.08 6 8.76 4.3 10.46-1.7 1.7-6.38-.23-10.46-4.3-4.07-4.08-6-8.76-4.3-10.46 1.7-1.7 6.38.23 10.46 4.3Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
